import * as types from '../../mutation-types'
import * as api from '../../api'

const state = {
  phoenix_setting: {},
  phoenix_settings: []
}

const getters = {
  singlePhoenixSetting: state => state.phoenix_setting,
  allPhoenixSettings: state => state.phoenix_settings,
  featureVoipEnabled: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.VOIP' &&
        ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  },
  featureVisualAlertEnabled: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.VISUAL_ALERT' &&
        ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  },
  featureSipEnabled: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.DEVICE.SIP' &&
        ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  },
  featureBarionetEnabled: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.DEVICE.BARIONET' &&
        ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  },
  featureRtpEnabled: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.DEVICE.RTP' &&
        ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  },
  featureG2SecureEnabled: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.G2_SECURE' &&
        ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  },
  featureTextNotificationWidgetEnabled: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps => ps.site_id === rootGetters.scopedSiteId && 
      ps.domain === 'PHOENIX.FEATURE.WIDGET.TEXT_NOTIFICATION' && 
      ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  },
  featureG2SecureHavenLockConnected: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.G2_SECURE' &&
        ps.setting === 'HAVENLOCK_ACCESS_TOKEN'
    )

    return setting !== undefined ? setting.value && setting.value !== '' : false
  },
  featureSMSEnabled: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.SMS' &&
        ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  },
  featureSMSMaxPhoneNumbers: (state, getters, rootState, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.SMS' &&
        ps.setting === 'MAX_PHONE_NUMBERS'
    )

    return setting !== undefined ? setting.value : '0'
  },
  featureMulticastEnabled: (state, rootGetters) => {
    let setting = state.phoenix_settings.find(
      ps =>
        ps.site_id === rootGetters.scopedSiteId &&
        ps.domain === 'PHOENIX.FEATURE.MULTICAST' &&
        ps.setting === 'ENABLED'
    )

    return setting !== undefined ? setting.value === '1' : false
  }
}

const actions = {
  getPhoenixSetting ({ commit, rootGetters }, data) {
    api.instance.get('phoenix_settings/' + rootGetters.scopedSiteId + '/' + data.domain + '/' + data.setting)
      .then(function (response) {
        const phoenixSetting = response.data.phoenix_setting
        commit(types.RECEIVE_PHOENIX_SETTING, phoenixSetting)
      })
  },
  editPhoenixSetting ({ commit }, phoenixSetting) {
    let phoenixSettings = []
    phoenixSettings.push(phoenixSetting)

    api.instance.put('phoenix_settings', phoenixSettings)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.EDIT_PHOENIX_SETTING, phoenixSetting)
          alert(response.data.message)
        } else {
          alert(response.data.message)
        }
      })
  },
  getPhoenixSettings ({ commit }, domain) {
    api.instance.get('phoenix_settings/' + domain)
      .then(function (response) {
        const phoenixSettings = response.data.phoenix_settings
        commit(types.RECEIVE_PHOENIX_SETTINGS, phoenixSettings)
      })
  },
  editPhoenixSettings ({ commit }, phoenixSettings) {
    api.instance.put('phoenix_settings', phoenixSettings)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.EDIT_PHOENIX_SETTINGS, phoenixSettings)
          alert(response.data.message)
        } else {
          alert(response.data.message)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_PHOENIX_SETTING] (state, phoenixSetting) {
    state.phoenix_setting = phoenixSetting
  },
  [types.EDIT_PHOENIX_SETTING] (state, phoenixSetting) {
    state.phoenix_setting = phoenixSetting
  },
  [types.RECEIVE_PHOENIX_SETTINGS] (state, phoenixSettings) {
    state.phoenix_settings = phoenixSettings
  },
  [types.EDIT_PHOENIX_SETTINGS] (state, phoenixSettings) {
    state.phoenix_settings = phoenixSettings
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
